//import { PnkAjax } from '../api/pnk-ajax';
import { PnkAjax } from '../pnk-react/ajax/pnk-ajax';


export function AddNewProfile(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Post('profiles/new.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}
export function UpdateProfile(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Put('profiles/update.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}
export function GetProfileList(store, data, token, SuccessCallBackFunc) {
  let loader = { isLoader: false, containerId: 'testpnk', size: 'small' };
  return PnkAjax(store).Post('profiles/search.json').ExtraData(data).AttachLoader(loader).AddHeader({ 'x-access-token': token }).OnSuccess(SuccessCallBackFunc).Do();
}

